import { render } from "./loading.vue?vue&type=template&id=477402b2&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=477402b2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477402b2"]])

export default __exports__